<template>
  <div class="markbox" v-show="loading">
<!--    <div class="loading_box"></div>-->
    <div class="loadEffect">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>

</template>

<script>
export default {
  name: 'loading',
  data() {
    return {
      loading: false
    }
  },
  created() {
    var that = this;
    this.bus.$on('loading', function(data) {
      that.loading = !!data;
    })
  }
}
</script>
<style scoped lang="less">
.loadEffect{
  width: 90px;
  height: 90px;
  position: relative;
  margin: 300px auto 0;
}
.loadEffect span{
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #409eff;
  position: absolute;
  -webkit-animation: load 1.04s ease infinite;
}
@-webkit-keyframes load{
  0%{
    opacity: 1;
  }
  100%{
    opacity: 0.2;
  }
}
.loadEffect span:nth-child(1){
  left: 0;
  top: 50%;
  margin-top:-8px;
  -webkit-animation-delay:0.13s;
}
.loadEffect span:nth-child(2){
  left: 14px;
  top: 14px;
  -webkit-animation-delay:0.26s;
}
.loadEffect span:nth-child(3){
  left: 50%;
  top: 0;
  margin-left: -8px;
  -webkit-animation-delay:0.39s;
}
.loadEffect span:nth-child(4){
  top: 14px;
  right:14px;
  -webkit-animation-delay:0.52s;
}
.loadEffect span:nth-child(5){
  right: 0;
  top: 50%;
  margin-top:-8px;
  -webkit-animation-delay:0.65s;
}
.loadEffect span:nth-child(6){
  right: 14px;
  bottom:14px;
  -webkit-animation-delay:0.78s;
}
.loadEffect span:nth-child(7){
  bottom: 0;
  left: 50%;
  margin-left: -8px;
  -webkit-animation-delay:0.91s;
}
.loadEffect span:nth-child(8){
  bottom: 14px;
  left: 14px;
  -webkit-animation-delay:1.04s;
}

.loadEffect{
  width: 90px;
  height: 90px;
  position: relative;
  margin: 300px auto 0;

}

.loadEffect span{
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #409eff;
  position: absolute;
  -webkit-animation: load 1.04s ease infinite;
}
@-webkit-keyframes load{
  0%{
    -webkit-transform: scale(1.2);
    opacity: 1;
  }
  100%{
    -webkit-transform: scale(.3);
    opacity: 0.5;
  }
}
.loadEffect span:nth-child(1){
  left: 0;
  top: 50%;
  margin-top:-10px;
  -webkit-animation-delay:0.13s;
}
.loadEffect span:nth-child(2){
  left: 14px;
  top: 14px;
  -webkit-animation-delay:0.26s;
}
.loadEffect span:nth-child(3){
  left: 50%;
  top: 0;
  margin-left: -10px;
  -webkit-animation-delay:0.39s;
}
.loadEffect span:nth-child(4){
  top: 14px;
  right:14px;
  -webkit-animation-delay:0.52s;
}
.loadEffect span:nth-child(5){
  right: 0;
  top: 50%;
  margin-top:-10px;
  -webkit-animation-delay:0.65s;
}
.loadEffect span:nth-child(6){
  right: 14px;
  bottom:14px;
  -webkit-animation-delay:0.78s;
}
.loadEffect span:nth-child(7){
  bottom: 0;
  left: 50%;
  margin-left: -10px;
  -webkit-animation-delay:0.91s;
}
.loadEffect span:nth-child(8){
  bottom: 14px;
  left: 14px;
  -webkit-animation-delay:1.04s;
}


.markbox{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}


  /*loading开始*/
  .loading_box {
    width: 45px;
    height: 45px;
    display: block;
    //animation: sunLoading 1s steps(12, end) infinite;
    background: transparent 	url('./../../assets/img/loading.png');
    background-size: 100%;
    margin:auto;
    position:absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right:0;
    transform: translate(-50%,-50%);
  }
  /*loading结束*/



</style>
